export class CategoryNavigation {
	static ShowAllCategories() {
		let $showAllCategories = $('.js-show-all-categories');
		let $categoryNavigationItems = $('.category-navigation__item');

		$showAllCategories.on('click', function (e) {
			let $this = $(this);
			let parentElement = $this.parents('.category-navigation');
			e.preventDefault();
			$categoryNavigationItems.removeClass('category-navigation__item--hidden');
			$showAllCategories.remove();
		});
	}

	//Handler for displaying quick link menu
	static ShowQuickLookMenu() {
		let $quickLook = $('.js-quick-look');
		$quickLook.on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			let $this = $(this);
			let $quickLookMenu = $this.parent().find('.category-navigation__quick-look');
			let $linkText = $this.find('span');

			if ($this.data('expanded') === true) {
				$this.data('expanded', false);
				$this.removeClass('cta-quick-look--expanded');
				$linkText.text('Quick Look');
				$quickLookMenu.fadeOut(250);
			} else {
				$this.data('expanded', true);
				$this.addClass('cta-quick-look--expanded');
				$linkText.text('Hide');
				$quickLookMenu.fadeIn(250);
			}

			CategoryNavigation.HideQuickLookMenus($this, $quickLookMenu);
		});

		//Prevent closing of menu when clicking links etc
		$('.category-navigation__quick-look').on('click', function (e) {
			e.stopPropagation();
		});
	}

	//Handler for closing menu's when clicking another "Quick Look" link or closing all open menu's when clicking outside the link/menu
	static HideQuickLookMenus($link: any = null, $quickLookMenu: any = null) {
		let $quickLookMenus = $('.category-navigation__quick-look').not($quickLookMenu);
		let $quickLookLink = $('.js-quick-look').not($link);
		let $quickLookLinkText = $('.js-quick-look').not($link).find('span');

		$quickLookMenus.fadeOut(250);
		$quickLookLinkText.text('Quick Look');
		$quickLookLink.data('expanded', false);
		$quickLookLink.removeClass('cta-quick-look--expanded');
	}

	static OnBodyClickHandler() {
		$('body').on('click', function () {
			CategoryNavigation.HideQuickLookMenus();
		});
	}

	static init() {
		CategoryNavigation.OnBodyClickHandler();
		CategoryNavigation.ShowAllCategories();
		CategoryNavigation.ShowQuickLookMenu();
	}
}

CategoryNavigation.init();
